// extracted by mini-css-extract-plugin
module.exports = {"level2":"Title_level2___ND6j","level3":"Title_level3__SfvK_","variantBig":"Title_variantBig__SxvfH","level4":"Title_level4__ALrNv","level5":"Title_level5__koTcZ"};